import { render, staticRenderFns } from "./shareAddress.vue?vue&type=template&id=6fef637d&scoped=true"
import script from "./shareAddress.vue?vue&type=script&lang=js"
export * from "./shareAddress.vue?vue&type=script&lang=js"
import style0 from "./shareAddress.vue?vue&type=style&index=0&id=6fef637d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef637d",
  null
  
)

export default component.exports